export default "__VITE_ASSET__ec698910__"